import axios from "axios";
import {
  getAuthToken,
  getRefreshToken,
  setAuthToken,
  clearAuthToken,
} from "./auth";

const api = axios.create({
  baseURL: `${process.env.REACT_APP_BE_BASE_URL}`,
});

let isRefreshing = false;
let refreshSubscribers = [];

const addRefreshSubscriber = (callback) => {
  refreshSubscribers.push(callback);
};

const notifySubscribers = (newToken) => {
  refreshSubscribers.forEach((callback) => callback(newToken));
  refreshSubscribers = [];
};

const refreshAccessToken = async () => {
  try {
    isRefreshing = true;
    const refreshToken = getRefreshToken();
    if (!refreshToken) throw new Error("No refresh token available");

    const response = await axios.post(
      `${process.env.REACT_APP_BE_BASE_URL}token/refresh`,
      {
        refreshToken,
      }
    );
    if (response.status === 430) {
      window.location.href = "/login";
    }

    const { accessToken } = response.data;
    setAuthToken(accessToken);

    isRefreshing = false;
    notifySubscribers(accessToken);
    return accessToken;
  } catch (error) {
    clearAuthToken();
    window.location.href = "/login";
    return Promise.reject(error);
  }
};

// ** Request Interceptor **
api.interceptors.request.use(
  (config) => {
    const token = getAuthToken();
    if (token) {
      config.headers["Authorization"] = `JWT ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// ** Response Interceptor **
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    
    if (
      error.response &&
      error.response.status === 401 &&
      !originalRequest._retry
    ) {
      originalRequest._retry = true;

      if (!isRefreshing) {
        try {
          const newToken = await refreshAccessToken();
          console.log('retryingg with refresh token', newToken.data.accessToken);
          originalRequest.headers["Authorization"] = `JWT ${newToken.data.accessToken}`;
          return api(originalRequest);
        } catch (refreshError) {
          return Promise.reject(refreshError);
        }
      }

      return new Promise((resolve) => {
        addRefreshSubscriber((newToken) => {
          originalRequest.headers["Authorization"] = `Bearer ${newToken}`;
          resolve(api(originalRequest));
        });
      });
    }

    return Promise.reject(error);
  }
);

export default api;